import { useContext } from "react";
import { chemsecSvg, marketplaceSvg } from "../../assets/icons";
import { AccountContext } from "../../Store/Account.store";
import SearchInput from "../HeaderSearch/HeaderSearch";
import Menu from "../Menu/Menu";
import styles from "./header.module.css";
import RegisterButton from "./RegisterButton/RegisterButton";
import SignInButton from "./SignInButton/SignInButton";
import ProfileButton from "./ProfileButton/ProfileButton";
import { Link } from "react-router-dom";

export default function Header() {
  const {accountData} = useContext(AccountContext);
  function SendToSignIn() {
    window.location.href = "/sign-in";
  }

  function SendToRegister() {
    window.location.href = "/register";
  }

  return (
    <div className={styles.headerContainer} id="headerContainer">
      <nav className={styles.nav}>
        <div className={styles.logo}>
          <a href="/">
            <span className={styles.chemsec}>{chemsecSvg}</span>
            <span className={styles.marketplace}>{marketplaceSvg}</span>
          </a>
        </div>
        <SearchInput />
        {accountData.isauthenticated == false ? (
          <>
            <SignInButton handleOnClick={SendToSignIn}/>
            <RegisterButton HandleOnClick={SendToRegister} />
          </>
        ) : (
          <>
            <ProfileButton />
            <div className={styles.advertise}>
              <Link to="/advertise-your-alternative" className="button button_white">Advertise your alternative</Link>
            </div>
          </>
        )
        }
        <Menu />
      </nav>
    </div>
  );
}
